<template>
  <v-dialog :value="visible" width="660" content-class="rounded-xl" @input="$emit('input', $event)" persistent>
    <v-sheet class="py-6 px-8">
      <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">얼리 제품 추가하기</p>

      <v-sheet class="mt-2 px-4">
        <v-text-field class="rounded-10" label="이름" dense outlined v-model="create.productName"></v-text-field>

        <!-- 컨셉 선택 -->
        <v-select class="mb-4" outlined dense hide-details :items="conceptList" v-model="create.concept" item-text="title" label="컨셉" :return-object="true"></v-select>

        <!-- promomotion code 선택 -->
        <SelectedPromotions :promotions="create.promotionCodes" @addPromotion="visiblePromotionSelect = true" />

        <v-text-field class="rounded-10 mt-6" label="한줄 설명" dense outlined v-model.trim="create.subTitle"></v-text-field>

        <v-text-field class="rounded-10 mt-2" label="Base 금액" dense outlined v-model.number="create.baseAmount" type="number" hide-spin-buttons></v-text-field>

        <div class="font-weight-bold text-body-1 py-2">유효 기간</div>
        <v-row>
          <v-menu v-model="startAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="create.startAtDate" label="시작일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="green"></v-text-field>
            </template>
            <v-date-picker v-model="create.startAtDate" no-title scrollable color="green" @input="startAtMenu = false"></v-date-picker>
          </v-menu>
          <v-menu v-model="endAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="create.endAtDate" label="종료일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="warning"></v-text-field>
            </template>
            <v-date-picker v-model="create.endAtDate" no-title scrollable color="warning" @input="endAtMenu = false"> </v-date-picker>
          </v-menu>
        </v-row>

        <!-- 상품 설명 페이지 -->
        <v-sheet>
          <div class="font-weight-bold text-h6 ml-4 mt-4">한글</div>
          <TipTapWriter class="tiptap_style mt-2" :options="options" :key="'ko' + componentKey" />
        </v-sheet>

        <v-sheet>
          <div class="font-weight-bold text-h6 ml-4 mt-4">영어</div>
          <TipTapWriter class="tiptap_style mt-2" :options="en.options" :key="'en' + en.componentKey" />
        </v-sheet>

        <v-sheet>
          <div class="font-weight-bold text-h6 ml-4 mt-4">일어</div>
          <TipTapWriter class="tiptap_style mt-2" :options="jp.options" :key="'jp' + jp.componentKey" />
        </v-sheet>

        <v-sheet class="d-flex justify-center mt-5">
          <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('input', false)">
            <v-icon small left>mdi-cancel</v-icon>
            취소하기
          </v-btn>
          <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="submit()">
            <v-icon small left>mdi-database-plus-outline</v-icon>
            추가하기
          </v-btn>
        </v-sheet>
      </v-sheet>
      <PromotionSelect :visible="visiblePromotionSelect" @input="(e) => (visiblePromotionSelect = e)" @add="addPromotion" />
    </v-sheet>
  </v-dialog>
</template>
<script>
import TipTapWriter from "@/components/tiptap/Writer"
import SelectedPromotions from "./SelectedPromotions"
import PromotionSelect from "./PromotionSelect"

export default {
  components: {
    TipTapWriter,
    SelectedPromotions,
    PromotionSelect,
  },
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
  },

  data: () => ({
    create: {
      productName: "",
      promotionCodes: [],
      concept: null,
      conceptName: "",
      subTitle: "",
      startAtDate: null,
      endAtDate: null,
      baseAmount: 0,
      description: null,
      description_en: null,
      description_jp: null,
    },
    startAtMenu: false,
    endAtMenu: false,

    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    en: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },

    jp: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },

    conceptList: [],
    visiblePromotionSelect: false,
  }),

  mounted() {
    this.$http
      .post("/api/concept/select/search", {
        params: {
          keyword: "",
        },
      })
      .then((res) => {
        this.conceptList = res.data
      })
  },

  methods: {
    submit: _.debounce(async function () {
      console.log("selected concept", this.create.concept)
      if (this.create.productName == "") {
        alert("상품명을 입력해 주세요")
        return
      }
      if (this.create.promotionCodes.length === 0) {
        alert("프로모션 코드를 선택해 주세요")
        return
      }
      if (!this.create.startAtDate) {
        alert("시작일자를 입력해 주세요")
        return
      }
      if (!this.create.endAtDate) {
        alert("종료일자를 입력해 주세요")
        return
      }

      if (!this.create.subTitle) {
        alert("상품 설명을 입력해 주세요")
        return
      }

      try {
        const res = await this.$http.post("/api/early/admin/insert", {
          productName: this.create.productName,
          promotionCodes: this.create.promotionCodes.map((e) => e.code).join(","),
          conceptId: this.create.concept.id,
          conceptName: this.create.concept.title,
          subTitle: this.create.subTitle,
          startAt: this.create.startAtDate,
          endAt: this.create.endAtDate,
          baseAmount: this.create.baseAmount,
          description: this.options.content,
          description_en: this.en.options.content,
          description_jp: this.jp.options.content,
        })
        this.$toast.success("상품이 정상 등록되었습니다.")
        this.$emit("complete")
      } catch (e) {
        console.log(e)
        alert("등록되지 않았습니다")
      }
    }, 500),

    addPromotion(promotion) {
      console.log("addPromotion")
      const found = this.create.promotionCodes.find((e) => e.id == promotion.id)
      if (found) {
        this.$toast.error("이미 등록되었습니다.")
        return
      }
      this.create.promotionCodes.push(promotion)
    },
  },
}
</script>
<style></style>
